import { navigate } from 'gatsby';
import { useEffect, useState } from 'react';

import * as ROUTES from '@constants/routes';

import { getQueryParams } from '@utils/url';

/**
 * Returns the shareId from the URL query parameter, or undefined if it does not exist.
 *
 * @returns {string | undefined} The shareId from the URL, or undefined if it is not present.
 */
export const useShareId = () => {
  const [shareId, setShareId] = useState<string>();

  useEffect(() => {
    // Get the share_id parameter from the URL, decode it, and set it as the state
    const { share_id } = getQueryParams();

    if (share_id === undefined) {
      // If the share_id parameter is not present, redirect to the login page
      navigate(ROUTES.LOGIN);
    } else if (typeof share_id === 'string') {
      // Set the decoded share_id as the state
      setShareId(share_id);
    }
  }, []);

  return shareId;
};
